module.exports = __webpack_public_path__ + "img/new-icon-sedang-diproses.a5bb8b20.svg";